import scrollNav from '../utils/scrollNav';
export default scrollNav;